function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.0522 24.25H1.6978C1.18328 24.25 0.75 23.7357 0.75 23.125C0.75 22.5143 1.18328 22 1.6978 22H17.0522C17.5667 22 18 22.5143 18 23.125C18 23.7357 17.5667 24.25 17.0522 24.25Z",
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.20671 18.8249C8.52407 18.8249 7.94922 18.2501 7.94922 17.5674V1.50749C7.94922 0.824852 8.52407 0.25 9.20671 0.25C9.88934 0.25 10.4642 0.824852 10.4642 1.50749V17.5674C10.4642 18.2501 9.88934 18.8249 9.20671 18.8249Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.21065 18.8251C8.8873 18.8251 8.56395 18.7173 8.31245 18.4658L2.42022 12.5376C1.91722 12.0346 1.91722 11.2442 2.42022 10.7771C2.92321 10.2742 3.71363 10.2742 4.1807 10.7771L10.0729 16.6694C10.5759 17.1724 10.5759 17.9628 10.0729 18.4299C9.85736 18.7173 9.53401 18.8251 9.21065 18.8251Z",
  fill: "white"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.21198 18.8248C8.88862 18.8248 8.56527 18.717 8.31377 18.4655C7.81077 17.9626 7.81077 17.1721 8.31377 16.7051L14.2419 10.7769C14.7449 10.2739 15.5353 10.2739 16.0024 10.7769C16.5054 11.2799 16.5054 12.0703 16.0024 12.5374L10.1102 18.4655C9.85868 18.717 9.53533 18.8248 9.21198 18.8248Z",
  fill: "white"
});

var SvgDownloadIcon = function SvgDownloadIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 25,
    viewBox: "0 0 18 25",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDownloadIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download-icon.d1da1596.svg";
export { ForwardRef as ReactComponent };